import { Stack, Box, Button, rgbToHex, Slide } from "@mui/material";
import React, { createRef, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { css, keyframes } from "@emotion/react";

import {
  AccountType,
  ActionType,
  Color,
  ContactType,
  FontStyle,
  navPaddingTop,
  NumToFullQuestion,
  QuestionData,
  SEPARATOR,
  signupIdx,
  schoolsIdx,
  Slug,
  SurveyButtonStyle,
  resumeIdx,
} from "../constants";
import HeartButton from "../components/HeartButton";
import CheckButton from "../components/CheckButton";
import SimpleButton from "../components/SimpleButton";
import Q0_Important from "../components/Questions/Q0_Important";
import SplashButton from "../components/SplashButton";
import Q1_Location from "../components/Questions/Q1_Location";
import Q2_Visa from "../components/Questions/Q2_Visa";
import Q3_Language from "../components/Questions/Q3_Language";
import Q4_Time from "../components/Questions/Q4_Time";
import Q5_Roles from "../components/Questions/Q5_Roles";
import Q6_Experience from "../components/Questions/Q6_Experience";
import Q7_Size from "../components/Questions/Q7_Size";
import Q8_Industries from "../components/Questions/Q8_Industries";
import Q9_NegativeIndustries from "../components/Questions/Q9_NegativeIndustries";
import Q10_Technologies from "../components/Questions/Q10_Technologies";
import Q11_NegativeTechnologies from "../components/Questions/Q11_NegativeTechnologies";
import Q12_Salary from "../components/Questions/Q12_Salary";
import Q13_Demographic from "../components/Questions/Q13_Demographic";
import Q14_Signup from "../components/Questions/Q14_Signup";
import Q15_Linkedin from "../components/Questions/Q15_Linkedin";
import Q16_Emails from "../components/Questions/Q16_Emails";
import Q17_Referral from "../components/Questions/Q17_Referral";
import Q_Resume_Upload from "../components/Questions/Q_Resume_Upload";
import Q_Education from "../components/Questions/Q_Education";
import SlideTransition from "../components/SlideTransition";
import * as apiService from "../service/ApiService";
import { useDispatch, useSelector } from "react-redux";

const styles = {
  container: {
    paddingTop: navPaddingTop,
    paddingBottom: "110px",
    backgroundColor: "white",
    // backgroundColor: Color.bgLight,
    minHeight: "100vh",
    // overflowX: 'hidden',
  },
  yourBestMatches: {
    ...FontStyle.headingBody,
    fontSize: "0.9rem",
    width: "100%",
    textAlign: "center",
    height: "2.67rem",
    // backgroundColor: 'rgb(0, 211, 131)',
    backgroundColor: Color.primary,
    // backgroundColor: Color.mainGreen
  },
  progressOuter: {
    width: "100%",
    height: "9.27px",
    // backgroundColor: 'transparent',
    backgroundColor: Color.bgMed,
  },
  progressInner: {
    // backgroundColor: 'rgb(0, 211, 131)',
    backgroundColor: Color.primary,
    height: "100%",
    transition: "width 0.5s",
  },
  questionTitle: {
    borderTop: "1px solid rgb(225, 225, 219)",
    ...FontStyle.title,
    fontSize: { xs: "1.83rem", sm: "2rem" },
    py: "28px",
    px: { xs: "8px", sm: 2 },
    backgroundColor: Color.bgLight,
    // backgroundColor: 'white',
    textAlign: "center",
    width: "100%",
  },
  questionDescription: {
    ...FontStyle.body,
    fontSize: "1rem",
  },
  endButtonContainer: {
    padding: "0.69rem",
    zIndex: 100,
    backgroundColor: "white",
    borderTop: "1px solid rgb(225, 225, 219)",
    position: "fixed",
    bottom: 0,
    width: "100%",
  },
  endButtonContainer2: {
    padding: "0.69rem",
    paddingTop: "2rem",
    zIndex: 100,
    backgroundColor: "white",
    // borderTop: '1px solid rgb(225, 225, 219)',
    // position: 'fixed',
    // bottom: 0,
    width: "100%",
  },
  endButtonContainerInner: {
    width: { xs: "100%", sm: "500px" },
    // px: "0.69rem",
  },
  bar: {
    // width: "40%",
    height: "1px",
    backgroundColor: "rgba(160, 160, 160, 0.7)",
  },
};
const slugToQuestion = {};
QuestionData.forEach((q, i) => {
  slugToQuestion[q.slug] = i;
});
const lastPage = QuestionData.length - 1;

const questionComponents = [
  Q0_Important,
  Q1_Location,
  Q2_Visa,
  // Q3_Language,
  Q4_Time,
  Q5_Roles,
  Q6_Experience,
  Q7_Size,
  Q8_Industries,
  Q9_NegativeIndustries,
  Q10_Technologies,
  // Q11_NegativeTechnologies,
  Q12_Salary,
  Q13_Demographic,
  Q14_Signup,
  Q_Resume_Upload,
  Q_Education,
  Q15_Linkedin,
  Q16_Emails,
  Q17_Referral,
];

const accountType = AccountType.standard;

const Survey = () => {
  const auth = useSelector((state) => state.auth);
  const loggedIn =
    auth.accountData.loginToken !== null &&
    auth.accountData.contactInfo !== null;
  const selections = useSelector((state) => state.survey.selections);
  const dispatch = useDispatch();
  const { section } = useParams();
  const navigate = useNavigate();
  const [questionNum, setQuestionNum] = React.useState(0);
  const [questionsDone, setQuestionsDone] = React.useState({});
  useEffect(() => {
    if (slugToQuestion[section] === undefined) return;
    setQuestionNum(slugToQuestion[section]);
  }, [section]);
  const [bodyHeight, setBodyHeight] = React.useState(0);
  const [refreshCount, setRefreshCount] = React.useState(0);
  const bodyRefs = useRef(QuestionData.map(() => createRef()));
  const [signedUp, setSignedUp] = React.useState(false);
  const [submitAfterSignup, setSubmitAfterSignup] = React.useState(false);

  const setSelections = (newSelections) => {
    // either newSelections is a function or an object
    if (typeof newSelections === "function") {
      const payload = newSelections(selections);
      // console.log('payload from function', payload)
      dispatch({ type: ActionType.updateSurvey, payload });
    } else {
      // console.log('payload from object', newSelections)
      dispatch({ type: ActionType.updateSurvey, payload: newSelections });
    }
  };

  // change target height of window when question changes
  // needed because carousel effect uses absolute positioning
  useEffect(() => {
    if (bodyRefs.current[questionNum].current) {
      setBodyHeight(
        Math.max(bodyRefs.current[questionNum].current.clientHeight, 450)
      );
    }
  }, [questionNum, refreshCount]);
  // scroll to top when question changes, smoothly
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [questionNum]);
  // actually set height of window when target height changes
  useEffect(() => {
    function handleResize() {
      setRefreshCount((prev) => prev + 1);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  // if user is of account type gig, redirect to gig survey
  useEffect(() => {
    if (auth.accountData.accountType === AccountType.gig) {
      navigate(Slug.surveyGigInitial);
    }
  }, [auth.accountData.accountType]);

  // go to next question
  const nextQuestion = (nextNum) => {
    navigate(Slug.survey.replace(":section", QuestionData[nextNum].slug));
  };

  // submit signup data with apiService.register
  const completeSignup = () => {
    const [firstName, lastName, contactInfo, password, emailConsent] =
      selections[signupIdx];
    const contactType = ContactType.email;
    console.log(
      "got data",
      firstName,
      lastName,
      contactInfo,
      password,
      contactType
    );
    apiService.register(
      dispatch,
      {
        firstName,
        lastName,
        contactInfo,
        password,
        contactType,
        accountType,
      },
      () => {
        setSignedUp(true);
      }
    );
  };
  // on signup, submit the survey in advance to save user's info (in case they don't complete the survey and come back later)
  useEffect(() => {
    if (signedUp && loggedIn && !submitAfterSignup) {
      setSubmitAfterSignup(true);
      submitSurvey();
    }
  }, [signedUp, loggedIn, submitAfterSignup]);

  useEffect(() => {
    // skip signup page if logged in
    if (
      auth.accountData.contactInfo &&
      auth.accountData.loginToken &&
      questionNum === signupIdx
    ) {
      nextQuestion(questionNum + 1);
    }
  }, [auth, questionNum]);

  const createSurveyData = () => {
    const surveyData = {};
    QuestionData.forEach(
      ({ column, options, useInputText, isImportant }, i) => {
        if (column === null) return;
        if (useInputText) {
          surveyData[column] = selections[i];
          return;
        }
        // surveyData[column] = selections[i].map((s, j) => options[s])
        surveyData[column] = options.filter((_, j) =>
          selections[i].includes(j)
        );
        if (isImportant) {
          surveyData[column + "_important"] = selections["important" + i].map(
            (s, j) => options[s]
          );
        }
      }
    );
    Object.keys(surveyData).forEach((key) => {
      surveyData[key] = surveyData[key].join(SEPARATOR);
    });
    console.log("survey data", surveyData);
    return surveyData;
  };
  const submitSurvey = (handleSuccess = null) => {
    const surveyData = createSurveyData();
    //submit data
    console.log("auth rn", auth.accountData);
    surveyData.contactInfo = auth.accountData.contactInfo;
    surveyData.contactType = auth.accountData.contactType;
    surveyData.loginToken = auth.accountData.loginToken;
    console.log("submitting", surveyData);
    apiService.submitSurvey(dispatch, surveyData, handleSuccess);
    // clear jobs in authReducer
    dispatch({ type: ActionType.setJobs, payload: null });
  };
  return (
    <Stack sx={styles.container} direction="column">
      <Box
        sx={{
          width: "100%",
          position: "relative",
          height: `${bodyHeight}px`,
          overflow: "hidden",
        }}>
        {questionComponents
          .map((q, i) => {
            return (
              <SlideTransition key={i} targetNum={i} currentNum={questionNum}>
                <Stack
                  direction="column"
                  ref={bodyRefs.current[i]}
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={0}>
                  <Stack
                    direction="column"
                    sx={styles.questionTitle}
                    alignItems="center"
                    justifyContent="center"
                    spacing={2}>
                    <Box>{QuestionData[i].question}</Box>
                    {QuestionData[i].description && (
                      <Box sx={styles.questionDescription}>
                        {QuestionData[i].description}
                      </Box>
                    )}
                  </Stack>
                  {questionNum === 0 && !loggedIn ? (
                    <Stack
                      direction="row"
                      sx={styles.yourBestMatches}
                      alignItems="center"
                      justifyContent="center">
                      {/* <AccessTimeIcon sx={{ height: '17px', width: '17px', marginRight: '0.25rem', }} /> */}
                      Your perfect match is 2 minutes away ⏰{" "}
                    </Stack>
                  ) : (
                    <Stack direction="row" sx={styles.progressOuter}>
                      {" "}
                      <Box
                        sx={{
                          ...styles.progressInner,
                          width: `${
                            ((questionNum + 1) / (lastPage + 1)) * 100
                          }%`,
                        }}
                      />{" "}
                    </Stack>
                  )}
                  <Box
                    sx={{
                      px: {
                        xs: "0.25rem",
                        sm: "0.75rem",
                        backgroundColor: "white",
                      },
                      width: "100%",
                    }}>
                    {q({
                      setRefreshCount,
                      questionNum: i,
                      options: QuestionData[i].options,
                      currentQuestionNum: questionNum,
                      selected: selections,
                      setSelected: setSelections,
                      setQuestionsDone,
                      nextQuestion: () => nextQuestion(i + 1),
                      accountType,
                      setSignedUp,
                    })}
                  </Box>

                  <Stack
                    direction="row"
                    sx={styles.endButtonContainer2}
                    alignItems="center"
                    justifyContent="center">
                    <Stack
                      direction="row"
                      sx={{
                        ...styles.endButtonContainerInner,
                        ...(questionNum === 0 && { maxWidth: "260px" }),
                      }}
                      alignItems="center"
                      justifyContent="center"
                      spacing={2}>
                      {questionNum !== 0 && (
                        <Button
                          sx={{
                            ...SurveyButtonStyle.defaultStyling,
                            ...SurveyButtonStyle.whiteColor,
                          }}
                          disableRipple
                          fullWidth
                          onClick={() => {
                            console.log(
                              "prev",
                              questionNum,
                              questionsDone[questionNum]
                            );
                            if (loggedIn && questionNum - 1 === signupIdx) {
                              // if logged in and prev question is signup, go two questions back
                              navigate(
                                Slug.survey.replace(
                                  ":section",
                                  QuestionData[questionNum - 2].slug
                                )
                              );
                            } else {
                              navigate(
                                Slug.survey.replace(
                                  ":section",
                                  QuestionData[questionNum - 1].slug
                                )
                              );
                            }
                          }}>
                          Back
                        </Button>
                      )}
                      <Button
                        sx={{
                          ...SurveyButtonStyle.defaultStyling,
                          ...SurveyButtonStyle.primaryColor,
                          // ...SurveyButtonStyle.gradientColor,
                          ...(!questionsDone[questionNum] &&
                            SurveyButtonStyle.disabledPrimary),
                        }}
                        disableRipple
                        disabled={!questionsDone[questionNum]}
                        fullWidth
                        onClick={() => {
                          console.log(
                            "next",
                            questionNum,
                            questionsDone[questionNum]
                          );
                          if (questionNum === signupIdx) {
                            completeSignup();
                            // submitSurvey();
                          } else if (questionNum === lastPage) {
                            submitSurvey();
                            //go to results page
                            navigate(Slug.results);
                          } else {
                            nextQuestion(questionNum + 1);
                          }
                        }}>
                        {questionNum === lastPage ? "Finish" : "Next"}
                      </Button>
                    </Stack>
                  </Stack>

                  {/* for returning users, offer a Save&Exit button */}
                  {loggedIn && (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={3}
                      sx={{
                        width: { xs: "100%", sm: "500px" },
                        paddingTop: "16px",
                        paddingBottom: "16px",
                      }}>
                      <Box sx={{ ...styles.bar, width: "100%" }} />
                      <Button
                        sx={{
                          ...SurveyButtonStyle.defaultStyling,
                          // ...SurveyButtonStyle.primaryColor,
                          ...SurveyButtonStyle.gradientColor,
                          // textTransform: "none",
                          // fontWeight: "normal",
                        }}
                        disableRipple
                        fullWidth
                        onClick={() => {
                          submitSurvey(() => navigate(Slug.jobResults));
                        }}>
                        {signedUp ? "Skip & View Matches" : "Save & Exit"}
                      </Button>
                    </Stack>
                  )}
                  {/* below is an unused Google disclaimer, required if we are using Google Drive to help upload resumes */}
                  {/* {questionNum === resumeIdx && (
                    <>
                      <Box
                        sx={{
                          ...FontStyle.body,
                          fontSize: "12px",
                          paddingTop: "60px",
                        }}>
                        Google Drive is a trademark of Google Inc. Use of this
                        trademark is subject to Google Permissions.
                      </Box>
                      <Box
                        sx={{
                          ...FontStyle.body,
                          fontSize: "12px",
                          paddingTop: "8px",
                        }}>
                        This website utilizes Google API services. You can view
                        the details of our Limited Use Disclosure{" "}
                        <a
                          href={Slug.googleApiServicesDisclosure}
                          target="_blank">
                          here
                        </a>
                        .
                      </Box>
                    </>
                  )} */}
                </Stack>
              </SlideTransition>
            );
          })
          .filter((_, i) => i !== signupIdx || !loggedIn)}
      </Box>
      {/* <Stack direction='row' sx={styles.endButtonContainer} alignItems='center' justifyContent='center'>
                <Stack direction='row' sx={styles.endButtonContainerInner} alignItems='center' justifyContent='center'
                    spacing={2}
                >
                    {questionNum !== 0 && <Button sx={{ ...styles.endButtonBack }} disableRipple fullWidth
                        onClick={() => {
                            console.log('prev', questionNum, questionsDone[questionNum])
                            if (loggedIn && questionNum - 1 === signupIdx) {
                                // if logged in and prev question is signup, go two questions back
                                navigate(Slug.survey.replace(':section', QuestionData[questionNum - 2].slug))
                            } else {
                                navigate(Slug.survey.replace(':section', QuestionData[questionNum - 1].slug))
                            }
                        }}>Back</Button>}
                    <Button sx={{ ...styles.endButton, ...(!questionsDone[questionNum] && styles.disabledEndButton) }}
                        disableRipple
                        disabled={!questionsDone[questionNum]}
                        fullWidth
                        onClick={() => {
                            console.log('next', questionNum, questionsDone[questionNum])
                            if (questionNum === signupIdx) {
                                completeSignup();
                            } else if (questionNum === lastPage) {
                                const surveyData = createSurveyData();
                                //submit data
                                surveyData.contactInfo = auth.accountData.contactInfo;
                                surveyData.contactType = ContactType.email;
                                surveyData.loginToken = auth.accountData.loginToken;
                                console.log('submitting', surveyData)
                                apiService.submitSurvey(dispatch, surveyData)
                                //go to results page
                                navigate(Slug.results)
                            } else {
                                nextQuestion(questionNum + 1)
                            }
                        }}
                    >
                        {questionNum === lastPage ? 'Finish' : 'Next'}
                    </Button>
                </Stack>
            </Stack> */}
    </Stack>
  );
};

export default Survey;
